class Panel {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.element = element;
    this.paragraph = this.element.querySelector('.panel__description');
    this.height = 0;

    setTimeout(() => {
      this.getParagraphHeight();
      this.initEvent();
    }, 100);
  }

  getParagraphHeight() {
    if (this.paragraph !== null) {
      this.paragraph.classList.remove('clamped');
      this.paragraph.parentElement.style.height = '100%';
      this.paragraph.style.height = 'auto';
      this.height = this.paragraph.offsetHeight;
      this.paragraph.style.height = '5.6rem';
      this.paragraph.parentElement.style.height = 'auto';
      this.paragraph.classList.add('clamped');
    }
  }

  initEvent() {
    this.element.addEventListener('mouseenter', this.start.bind(this));
    this.element.addEventListener('mouseleave', this.end.bind(this));
  }

  start() {
    this.element.classList.add('hovered');
    this.paragraph.classList.remove('clamped');
    this.paragraph.style.height = `${this.height}px`;
  }

  end() {
    this.element.classList.remove('hovered');
    this.paragraph.style.height = '5.6rem';
    this.paragraph.addEventListener('transitionend', () => {
      this.paragraph.classList.add('clamped');
    }, { once: true });
  }
}

export default Panel;
